export const AptitudeStyle = {

    variants: {
      wrapper: {
        '.results': {
          display: 'block',
          clear: 'both',
          marginTop: '1rem',
        },
        '.resultsInner': {
          padding: '1rem 1rem 1rem 2rem',
          whiteSpace: 'break-spaces',
          border: '1px solid #333',
          borderRadius: '10px',
        },
        '.hero': {
          display: 'flex',
          alignItems: 'center',
        },
        '.heroImage': {
          width: [0, 0, 0, 'auto'],
        },
        '.aptitudeWrapper': {
          display: 'flex',
          padding:"2rem",
          border:'1px solid #333',
          borderRadius: '5px',
        },
        '.heroImageBox': {
          width: '30%',
          display: 'flex',
          alignItems: 'center',
          alignSelf: 'flex-start',
        },
        '.heroImageLeft': {
          marginRight: '5rem',
        },
        '.heroImageRight': {
          marginLeft: '5rem',
        },
        '.heroImageImg': {
          width: [0, 0, 0, 'auto'],
        },
        '.aptitudeCenter': {
          minHeight: 'auto',
        },
        '.aptitudeEditBox': {
          display:"flex",
          justifyContent:"space-between",
          marginTop:'1rem',
        },
        '.aptitudeEditInnerBox': {
          display:"flex",
          justifyContent:"space-between",
          alignItems:"center",
          width:'100%',
        },
        '.aptitudeBox': {
          maxWidth:'33%',
        },
        '.editButtonWrap': {
          display:"flex",
          justifyContent:"flex-end",
          marginTop: '1rem',
        },
        '.bold': {
          fontWeight:'bold',
          textTransform:'uppercase',
        },
        '.aptitudeButton': {
          float:'right',
          marginRight:'7%',
          marginTop:'1rem',
        },
        '.aptitudeTestLinkRetake': {
          background:'#edf2f7',
          border:'1px solid #333',
          borderRadius:'5px',
          padding:'.5rem .4rem',
          cursor:'pointer',
          _hover: {
            background: '#e2e8f0',
          },
        },
        '.aptitudeTestLink': {
          background:'ORANGE',
          border:'1px solid #333',
          borderRadius:'5px',
          padding:'.5rem .4rem',
          cursor:'pointer',
          _hover: {
            background: 'ORANGE_HOVER',
          },
        },
        // Responsive behavior for TestLink rows
        '.testLinkRow': {
          // default keeps existing layout
        },
        '.testLinkLeft': {
          marginTop:'-.3rem',
          // default styles set inline in component
        },
        '.testLinkRight': {
          // default styles set inline in component
        },
        '.testLinkDescription' : {
          fontSize: '15px',
          paddingLeft: '8px',
          marginLeft: '1.8rem',
          maxWidth: '60%',
          fontStyle: 'italic',
          marginTop: '-1.3rem',
        },
        '@media screen and (max-width: 1225px)': {
          '.testLinkRow': {
            flexWrap: 'wrap',
          },
          '.testLinkLeft': {
            width: '100%',
          },
          '.testLinkRight': {
            width: '100%',
            justifyContent: 'flex-start',
            marginTop: '.5rem',
          },

          '.testLinkDescription' : {

            marginTop: '0',
          },
        },
      },
    },

  }
;

